import { createSelector } from 'reselect';
import { getSortedActivities } from 'lib/selectors/getSortedActivities';
import { getLatestActivitySetRef } from 'lib/selectors/getLatestActivitySetRef';
import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';
import { getCurrentLaborTicket } from 'lib/selectors/getLaborTickets';

const defaultLatestActivities = [];

export const getLatestActivitySetActivities = createSelector(
  [
    getLatestActivitySetRef,
    getSortedActivities,
    getPostLaborUpdatesOnNats,
    getCurrentLaborTicket,
  ],
  (
    latestActivitySetRef,
    sortedActivities,
    natsFlowEnabled,
    currentLaborTicket
  ) => {
    // NATS mode: synthesize activities from labor ticket
    if (natsFlowEnabled) {
      if (!currentLaborTicket) {
        return defaultLatestActivities;
      }

      const hasOpenTicket = currentLaborTicket?.state === 'OPEN';
      const endBehavior = currentLaborTicket?.customFields?.endBehavior;
      const isKeptOpen = endBehavior === 'keep-open';

      if (!hasOpenTicket && !isKeptOpen) {
        return defaultLatestActivities;
      }

      const activityMode =
        currentLaborTicket.type?.toLowerCase() || 'production';
      // Synthesize a single activity representing the labor ticket duration
      return [
        {
          activityRef: null,
          activitySetRef: null,
          activityTypeRef: activityMode === 'setup' ? 'setup' : 'production',
          activityMode,
          start: currentLaborTicket.clockIn,
          end: hasOpenTicket ? null : currentLaborTicket.clockOut,
        },
      ];
    }

    if (
      !latestActivitySetRef ||
      (sortedActivities && !sortedActivities.length)
    ) {
      return defaultLatestActivities;
    }
    return sortedActivities.filter((a) => {
      return a.activitySetRef === latestActivitySetRef;
    });
  }
);
